<script lang="ts">
  import type { ProgressStepContext } from "@kontextwerk/web-sdk/ui/navigation/ProgressSteps.svelte"
  import type {
    DemoResetProfileDraft,
    DemoResetProfileOutput,
  } from "../../_shared/_logic/demo-data-reset-contract"
  import DemoAccessProfileStep from "../../_shared/_modules/demo-access-profile-step"

  const {
    ctx,
    initial,
    output = null,
    adminAccessEmail,
    onOutput,
    onEdit,
  }: {
    ctx: ProgressStepContext
    initial: DemoResetProfileDraft
    output?: DemoResetProfileOutput | null
    adminAccessEmail: string
    onOutput: (output: DemoResetProfileOutput) => void
    onEdit: () => void
  } = $props()
</script>

<DemoAccessProfileStep
  {ctx}
  title="Gesellen-Zugang"
  description="Legen Sie Anmeldung und Ansprechpartner-Kontaktdaten für den Gesellen fest."
  helpModalTextId="organizationTestDataGeselle"
  actionBoxLabel="Geselle konfigurieren"
  roleDescription="Der Geselle erhält Mitarbeiterrechte und betreut die zweite Hälfte der Beispiel-Liegenschaften."
  {initial}
  {output}
  otherAccessEmail={adminAccessEmail}
  {onOutput}
  {onEdit}
/>
